import React, { useEffect, useState } from 'react';
import { Button, Col, Dropdown, Form, Modal, Row, Tab, Tabs } from 'react-bootstrap';
import search from "../../assets/search.svg";
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import ReactPaginate from 'react-paginate';
import { faFile, faDownload, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TopNavBar from '../Layout/TopNavBar';
import { showAlert, showError, showSuccess } from '../utills/sweetAlert';
import { callApi } from '../utills/api';
import "../auth/element.css";
import plus from "../../assets/plus.svg";
import upload from "../../assets/upload.svg";
import MinusAdjustment from "../../assets/max-adjustment.svg";
import MinAdjustment from "../../assets/add-icon.svg";
import PdfAdd from './addPdf';
import ContentAdd from './addContent';
import BackNavigation from '../Common/BackNavigation';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Hourglass } from "react-loader-spinner";


interface RowData {
  title: string;
  image: string | null;
  errorMessage: string;
  successMessage: string;
}

const Dashboard: React.FC = () => {
  const location = useLocation();
  const { masterId, subId } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [removedRowIds, setRemovedRowIds] = useState<number[]>([]);
  const [removedListRowIds, setRemovedListRowIds] = useState<number[]>([]);
  const [removedContentImageRowIds, setRemovedContentImageRowIds] = useState<number[]>([]);

  console.log("useLocation id___", masterId, subId);

  useEffect(() => {
    if (masterId && subId) {
      getEditSelect();
      showInputsParentApi(masterId)
    }
  }, []);
  useEffect(() => {
    if (masterId && subId) {
      setState((prevState) => ({
        ...prevState,
        MasterId: masterId,
        SiteId: subId,
        EditMasterId:masterId,
        EditSubId:subId
      }));
      console.log("state.SiteId-->", state.SiteId);
    }
  }, [masterId, subId]);


  const [state, setState] = useState({
    CatId: "",
    MasterId: "",
    SiteId: "",
    EditMasterId:"",
    EditSubId:"",
    SubcategoryName: "",
    MasterOptionselect: [],
    parentDropDownSelect: [],
    EditDataselect: [],
    ImageMainTitle: "",
    PdfMainTitle: "",

  });
  const navigate = useNavigate();
  const [rows, setRows] = useState([
    {
      title: '',
      subtitle: '',
      attachment: [],
      updateStatus: true

    },
  ]);

  const [pdfRows, setPdfRows] = useState([
    { subtitle: '', attachment: [], errorMessage: '', successMessage: '', pdfName: '', updateStatus: true },
  ]);

  const [content, setContents]: any = useState([
    { title: '', description: '', list: [{ value: '' }], attachment: [] },
  ]);

  const [isMainTitleRequired, setIsMainTitleRequired] = useState(false);

  const validateFile = (file: File, rowIndex: number) => {
    const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    if (!validTypes.includes(file.type)) {
      updateRow(rowIndex, "errorMessage", "Unsupported file format. Please upload JPEG, PNG, or SVG.");
      return false;
    }
    return true;
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, rowIndex: number) => {
    const file = event.target.files?.[0];
    if (file && validateFile(file, rowIndex)) {
      const imageType = file.type.replace("image/", "");
      console.log("imageType -->", imageType);
      convertFileToBase64(file, rowIndex, imageType);
      updateRow(rowIndex, "errorMessage", ""); 

    }else {
      console.log("3333");
      updateRow(
          rowIndex,
          "errorMessage",
          "Unsupported file format. Please upload JPEG, PNG, or SVG."
      );
  }
  };

  const convertFileToBase64 = (file: File, rowIndex: number, imageType: string) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64data = reader.result as string;
      // Update the attachment array in the row
      updateRow(rowIndex, "attachment", [
        ...(rows[rowIndex].attachment || []),  // Maintain existing attachments
        {
          imageData: base64data,
          imageType: imageType,
          updateStatus: true,
          errorMessage:"",

        }
      ]);

      // Set success message
      updateRow(rowIndex, "successMessage", "File uploaded successfully!");
      updateRow(rowIndex, "errorMessage", "");  // Clear any previous error message
    };
    reader.onerror = () => {
      updateRow(rowIndex, "errorMessage", "Error converting file to Base64.");
    };
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>, rowIndex: number) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && validateFile(file, rowIndex)) {
      const imageType = file.type;
      convertFileToBase64(file, rowIndex, imageType);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const updateRow = (index: any, field: any, value: any) => {
    let sanitizedValue = value;

    if (typeof value === 'string') {
      // sanitizedValue = value.trim().replace(/ {2,}/g, ' '); 
       sanitizedValue = value.replace(/ {2,}/g, ' ');
    }
   
    const updatedRows: any = [...rows];
    updatedRows[index][field] = sanitizedValue;
    setRows(updatedRows);
    const areAllFieldsFilled = updatedRows.every((row: { title: any; subtitle: any; }) => row.title || row.subtitle);
    setIsMainTitleRequired(areAllFieldsFilled);
  };

  const handleAddRow = () => {
    setRows([...rows, { title: '', subtitle: '', attachment: [], updateStatus: true }]);
  };

  const handleRemoveRow = (index: any, id: any) => {
    setRemovedRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    setIsMainTitleRequired(updatedRows.every(row => row.title || row.subtitle));
    console.log("array---removedRowIds--->", removedRowIds);

  };

  useEffect(() => {
    getMasterselect();
  }, []);

  const getMasterselect = () => {
    callApi("GET", "masterDropdown.php", "")
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          setState((prevState) => ({
            ...prevState,
            MasterOptionselect: response.data
          }));
        }
      })
      .catch((err: any) => {
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
  }

  const masterOnchange = (event: any) => {
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    showInputsParentApi(value);
  }

  const SiteOnchange = (event: any) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/ {2,}/g, ' ');

    setState((prevState) => ({
      ...prevState,
      [name]: sanitizedValue ,
    }));
  }

  const showInputsParentApi = (type: any) => {
    let request = {
      masterId: type,
    };
    callApi("POST", "subCategoryDropdown.php", request)
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          setState((prevState) => ({
            ...prevState,
            parentDropDownSelect: response.data,
          }));
        }
      })
      .catch((err: any) => {
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
  };

  const updatePdfRow = (index: number, newData: Partial<RowData>) => {
    setPdfRows(prevRows =>
      prevRows.map((row, rowIndex) => (rowIndex === index ? { ...row, ...newData } : row))
    );
  };

  const handleAddPdfRow = () => {
    setPdfRows([...pdfRows, {  subtitle: '', attachment: [], errorMessage: '', successMessage: '', pdfName: '', updateStatus: true }]);
  };

  const handleRemovePdfRow = (index: number, id: any) => {
    setRemovedRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);
    setPdfRows(prevRows => prevRows.filter((_, rowIndex) => rowIndex !== index));

  };

  useEffect(() => {
    console.log("array---removedRowIds--->", removedRowIds);
  }, [removedRowIds]);

  const contentUpdateRow = (index: any, newData: any) => {
    setContents((prevRows: any) =>
      prevRows.map((row: any, rowIndex: any) =>
        rowIndex === index ? { ...row, ...newData } : row
      )
    );
  };

  const contentHandleAddRow = () => {
    setContents([...content, {
      title: '', description: '', list: [{ value: '' }]
    }]);
  };

  const contentHandleRemoveRow = (index: number, id: any) => {
    setRemovedRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);
    setContents(content.filter((_: any, rowIndex: any) => rowIndex !== index));
  };
  const contentHandleAddList = (rowIndex: number) => {
    setContents((prevRows: any) =>
      prevRows.map((row: any, index: any) =>
        index === rowIndex
          ? { ...row, list: [...row.list, { value: '' }] }
          : row
      )
    );
  };

  const contentHandleRemoveList = (rowIndex: number, listIndex: number, id: any) => {
    console.log("surua");
    
    setRemovedListRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);

    setContents((prevRows: any) =>
      prevRows.map((row: any, index: any) =>
        index === rowIndex
          ? { ...row, list: row.list.filter((_: any, i: any) => i !== listIndex) }
          : row
      )
    );
  };

  const handleRemoveFileUpload = (rowIndex: any, fileIndex: any, fileId: any) => {
    console.log("working");
    
    setRemovedContentImageRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, fileId]);
  }
    useEffect(() => {
    console.log("array---removedContentImageRowIds--->", removedContentImageRowIds);
  }, [removedContentImageRowIds]);
  const handleUpdate = (event: any) => {
    console.log("coming");
    console.log("coming");
    
    const form = event.target.form;
    if (form.checkValidity() === false) {
      console.log("Form validation failed.");
      return;
    }
    event.preventDefault();


  }
  

  // Example function to handle API submission
  const handleSubmit = (event: any) => {
    console.log("coming");
    
    const form = event.target.form;
    if (form.checkValidity() === false) {
      console.log("Form validation failed.");
      return;
    }
    event.preventDefault();

    // console.log("Image rows--->",rows);
    // console.log("pdf rows--->",pdfRows);
    // console.log("content rows--->",content);
    // console.log("ImageMainTitle--->",state.ImageMainTitle);
    // console.log("PdfMainTitle--->",state.PdfMainTitle);
    // console.log("content[0].tittle",content[0].title);
    
    
    event.preventDefault();

    if(state.ImageMainTitle ||state.PdfMainTitle || content[0].title ) {
    const payload = {
      masterId: state.MasterId,
      subId: state.SiteId,
      ImageMainTitle: state.ImageMainTitle,
      image: rows,
      pdf: pdfRows,
      content: content,
      PdfMainTitle: state.PdfMainTitle,
      deletedIds:removedRowIds,
      deletedListIds:removedListRowIds,
      deletedAttachementIds:removedContentImageRowIds
    }
    let apiName;
    if (!isEmpty(masterId)) {
      apiName = 'sectionUpdate.php'
      setLoading(true);
    } else {
      apiName = 'sectionInsert.php'
      setLoading(true);
    }
    callApi("POST", apiName, payload)
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          setLoading(false);

          showSuccess("Success!", "  Successfully!");
          if (window.history.length === 0) return navigate('/dashboard');
          navigate(-1);
        }
      })
      .catch((err: any) => {
        setLoading(false);
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
    }else {
      showError(
          "Failed", "Please any One Section Fill");
  }


  };

  const handleImageClose = (index: any) => {
    setRows((prevRows) =>
      prevRows.map((row, i) =>
        i === index ? { ...row, imageName: null, updateStatus: true } : row
      )
    );
  };
  const handleContentImageClose = (rowIndex: any, fileIndex: any) => {
    setContents((prevRows: any) =>
      prevRows.map((row: any, i: any) =>
        i === rowIndex
          ? {
            ...row,
            attachment: row.attachment.map((file: any, index: any) =>
              index === fileIndex ? { ...file, imageName: null } : file
            ),
          }
          : row
      )
    );
  };
  const handlePDFClose = (index: any) => {
    setPdfRows((prevRows: any) =>
      prevRows.map((row: any, i: any) =>
        i === index ? { ...row, pdfName: null, updateStatus: true } : row
      )
    );
  };

  const getEditSelect = () => {
    let req = {
      masterId: masterId,
      subId: subId
    };
    callApi("POST", "sectionSingleSelect.php", req)
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data) {
          console.log("response--->image", response.data.image);
          setRows(response.data.image);
          setPdfRows(response.data.pdf);
          setContents(response.data.content);
          setState((prevState) => ({
            ...prevState,
            ImageMainTitle: response.ImageMainTitle,
            PdfMainTitle: response.PdfMainTitle
          }));
        } else {
          console.warn("No image data found in the response");
          setRows([]); // Set an empty array to avoid undefined issues
        }
        console.log("rows--->", rows);

      })
      .catch((err: any) => {
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
  }

  useEffect(() => {
    console.log("setting rows data-->", rows);

  }, [rows]);
  return (

    <>
      <div className="mobile_nav_bar">
        <TopNavBar />
      </div>
      <div className='mblcontent'>
        <form>
          <Row className='webview'>
            <div className="category-header">
              <Col lg="9" md="9" >
                <BackNavigation />
                <h3 className="category-title mt-2">
                  {masterId ? "Edit Page" : "Add Page"}
                </h3>
              </Col>
            </div>
          </Row>
          <Row className='mblview mbldashboard'>
            <div className="category-header">
              <Col lg="8" md="8">
                <BackNavigation />
                <h3 className="category-title mt-2">
                  Add Page
                </h3>
              </Col>
            </div>
          </Row>
          <Row className=''>
            <Col lg="3" md="3" >
              <Form.Select
                aria-label="Default select example"
                name="MasterId"
                required
                onChange={masterOnchange}
                value={state.MasterId}
                disabled={!!state.EditMasterId}
              >
                <option value="">Select Master</option>
                {state.MasterOptionselect.map((categery: any) => (
                  <option key={categery.value} value={categery.value}>
                    {categery.label}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col lg="3" md="3" >
              <Form.Select
                aria-label="Default select example"
                name="SiteId"
                required
                onChange={SiteOnchange}
                value={state.SiteId}
                disabled={!!state.EditSubId}
              >
                <option value="">Select Site</option>
                {state.parentDropDownSelect.map((categery: any) => (
                  <option key={categery.value} value={categery.value}>
                    {categery.label}
                  </option>
                ))}

              </Form.Select>
            </Col>

          </Row>
          <br />

          <Tabs
            defaultActiveKey="Images"
            id="justify-tab-example"
            className="mb-3 "
            justify
          >
            <Tab eventKey="Images" title="Images">
              <Row>
                <Col md="6" lg="6">
                  <input
                    type="text"
                    className="form-control bgborder"
                    placeholder="Main Title"
                    minLength={2}
                    onChange={SiteOnchange}
                    value={state.ImageMainTitle}
                    name='ImageMainTitle'
                    required={!!rows[0]?.attachment && rows[0].attachment.length > 0} 
                  />
                </Col>
              </Row>
              <Row>
                {rows.length > 0 ? (
                  rows.map((row: any, index) => (
                    <React.Fragment key={index}>
                      <Col md="3" className="flexalignitemcenter mt-4 mb-4">
                        <input
                          type="text"
                          className="form-control bgborder"
                          placeholder="Enter Title"
                          minLength={2}
                          value={row.title}
                          required={!!state.ImageMainTitle}
                          onChange={(e) => updateRow(index, 'title', e.target.value)}
                        />
                      </Col>
                      <Col md="3" className="flexalignitemcenter">
                        <input
                          type="text"
                          className="form-control bgborder"
                          placeholder="Enter Sub Title"
                          minLength={2}
                          maxLength={450}
                          value={row.subtitle}
                          required={!!state.ImageMainTitle}
                          onChange={(e) => updateRow(index, 'subtitle', e.target.value)}
                        />
                      </Col>

                      <Col md="4" lg="4" className='mb-3 flexalignitemcenter'>
                        {isEmpty(row.imageName) && (
                          <div
                            className="file-upload"
                            onDrop={(e) => handleDrop(e, index)}
                            onDragOver={handleDragOver}
                          >
                            <input
                              type="file"
                              id={`file-input-${index}`}
                              // style={{ display: 'none' }}
                              onChange={(e) => {
                                handleFileChange(e, index)
                              }}
                          required={!!state.ImageMainTitle}

                            />
                            <div
                              className="upload-icon"
                              onClick={() => document.getElementById(`file-input-${index}`)?.click()}
                            >
                              <img src={upload} alt="Upload Icon" />
                            </div>
                            <div className="drag-drop-area">
                              <p>
                                Drag and Drop file here or{' '}
                                <label htmlFor={`file-input-${index}`} style={{ cursor: 'pointer' }}>
                                  Choose file
                                </label>
                              </p>
                              <p className="file-info">Supported formats : JPEG, PNG, SVG.</p>
                              <p style={{color:"red"}}>Minimum upload size (484px X 530px)</p>
                              {row.attachment && row.attachment.length > 0 ? (
                                row.attachment.map((file: any, fileIndex: any) => (
                                  <div key={fileIndex} className="file-info">
                                    {file.imageType.split('/')[1]} file added
                                  </div>
                                ))
                              ) : (
                                <div>No files attached</div>
                              )}
                               {row.errorMessage && (
                                                            <div className="error-message" style={{ color: "red" }}>
                                                                {row.errorMessage}
                                                            </div>
                                                        )}

                            </div>
                          </div>
                        )}

                        {row.imageName && (
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={row.imageName}
                              alt="Uploaded Icon"
                              style={{ width: "100px" }}
                            />
                            <span
                              style={{

                                cursor: "pointer",
                                fontSize: "18px",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                padding: "2px 6px",
                                boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                              }}
                              onClick={() => handleImageClose(index)}
                            >
                              &times;
                            </span>
                          </div>
                        )}
                      </Col>
                      <Col md="2" lg="2" className="flexalignitemstart">
                        <img
                          style={{ width: '28px', cursor: 'pointer' }}
                          src={MinusAdjustment}
                          alt="Remove icon"
                          onClick={() => handleRemoveRow(index, row.id)}
                        />
                      </Col>
                    </React.Fragment>
                  ))
                ) : (
                  <p>No data available</p>
                )}
                <Col md="2" lg="2" className="flexalignitemstart">
                  <div
                    className="more-btn d-flex align-items-center justify-content-center"
                    onClick={handleAddRow}
                  >
                    <img style={{ marginRight: '10px', width: '12px', height: '12px' }} src={MinAdjustment} alt="add-icon" /> Add more
                  </div>
                </Col>
                <Col md="2" lg="2">

                </Col>
              </Row>
            </Tab>
            <Tab eventKey="PDF" title="PDF">
              <PdfAdd rows={pdfRows}
              PdfMainTitle={state.PdfMainTitle}
                updateRow={updatePdfRow}
                handleAddRow={handleAddPdfRow}
                handleRemoveRow={handleRemovePdfRow}
                handlePDFClose={handlePDFClose}
                onChange={SiteOnchange}
              />
            </Tab>
            <Tab eventKey="Content" title="Content">
              <ContentAdd rows={content}
                updateRow={contentUpdateRow}
                handleAddRow={contentHandleAddRow}
                handleRemoveRow={contentHandleRemoveRow}
                handleAddList={contentHandleAddList}
                handleRemoveList={contentHandleRemoveList}
                handleImageClose={handleContentImageClose}
                handleRemoveFileoneUpload={handleRemoveFileUpload} />

            </Tab>

          </Tabs>
          <br />
          <div className='flexend'>
          <button className="save-btn"
              type={!isEmpty(masterId) ? 'submit' : 'submit'}
              onClick={handleSubmit}>
              {!isEmpty(masterId) ? 'Update' : 'Save'}
            </button>

           
          </div>
        </form>
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            <Hourglass visible={true} height={50} width={50} />
          </div>
        </div>
      )}

    </>
  )
}

export default Dashboard